<app-header
  *transloco="let t; read: 'relations'"
  listType="relation"
  [title]="t('pageTitle') | capitalize"
  [searchPlaceHolder]="t('searchTitle')"
  (onSearchInput)="onSearchInput($event)"
  [searchResults]="searchResults.asObservable()"
  [additionalSection]="storedQueriesDrawer"
></app-header>

<ng-template #storedQueriesDrawer>
  <app-storedqueries-drawer handle="HSRELATIONS" [open]="showStoredQueries" (openClose)="showStoredQueries = $event" (filterData)="onStoredQueryClicked($event)"></app-storedqueries-drawer>
</ng-template>

<div class="page">
  <app-relation-list [relationsListing]="relationsListing"></app-relation-list>
  <app-no-results *ngIf="relationsListing.length && relationsListing[0].items.length == 0 && relationsLoading == false"></app-no-results>
  <app-load-more-button
    [showLoadMoreButton]="showLoadMoreButton"
    (buttonClicked)="onNextPage()"
  ></app-load-more-button>

  <app-create-relation></app-create-relation>
</div>
